import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgMoreSelectedNavIcon(props) {
  return jsx("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M10.62 5.24a1.62 1.62 0 1 0 0-3.24 1.62 1.62 0 0 0 0 3.24ZM10.62 11.49a1.62 1.62 0 1 0 0-3.24 1.62 1.62 0 0 0 0 3.24ZM10.62 17.74a1.62 1.62 0 1 0 0-3.24 1.62 1.62 0 0 0 0 3.24Z",
    fill: "currentColor"
  }));
}

export { SvgMoreSelectedNavIcon as default };
